import { createFileRoute, useSearch } from '@tanstack/react-router'
import { GovernanceView } from '../../../components/group-steering/GovernanceView'

export const Route = createFileRoute('/$org/group/governance')({
    component: GovernanceRoute,
})

function GovernanceRoute() {
    const { org } = Route.useParams()
    const search = useSearch({ from: '/$org/group' })
    return <GovernanceView org={org} period={search.period ?? '90d'} />
}
